import {createTypedReducerWithImmer} from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Draft } from "immer";

export interface SurveyFormState {
    fieldValues: SafeDictionary<string>;
}

export const initialState: SurveyFormState = {
    fieldValues: {},
};


export const customSurveyReducer = {
    "Custom/SurveyForm/ClearForm": (draft: Draft<SurveyFormState>) => {
        draft.fieldValues = {};
    },
    "Custom/SurveyForm/SetFieldValue": (
        draft: Draft<SurveyFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, customSurveyReducer);
